import { Autorenew } from '@mui/icons-material'
import { IconButton, keyframes, Tooltip } from '@mui/material'
import React, { useState } from 'react'

function RefreshButtonSpinner({ onClick, tittle='Reiniciar' }) {
    const [isSpinning, setIsSpinning] = useState(false);

    const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;

    const handleClick = () => {
        if (onClick) onClick();
        setIsSpinning(true);
        setTimeout(() => setIsSpinning(false), 1000);
    };

    return (
        <Tooltip title={tittle}>
            <IconButton onClick={handleClick}>
                <Autorenew
                    sx={{
                        width: '20px',
                        animation: isSpinning ? `${spin} 0.4s linear infinite` : 'none'
                    }}
                />
            </IconButton>
        </Tooltip>

    )
}

export default RefreshButtonSpinner
